export function isCoordinateMatched(pos1, pos2) {
  return (
    pos1.length !== 0 &&
    pos2.length !== 0 &&
    pos1[0] === pos2[0] &&
    pos1[1] === pos2[1]
  )
}



// WEBPACK FOOTER //
// ./src/assets/js/tool/coordinateUtils.js